import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{hide-application-sidebar}}

{{#if this.message}}
  <div class="alert {{this.alertClass}}">{{this.message}}</div>
{{/if}}
{{#unless this.loadError}}
  <h3>{{this.secondFactorTitle}}</h3>
  {{#if this.customDescription}}
    <p class="action-description">{{this.customDescription}}</p>
  {{/if}}
  <p>{{this.secondFactorDescription}}</p>
  {{#if this.showSecurityKeyForm}}
    <div id="security-key">
      <DButton
        @action={{this.authenticateSecurityKey}}
        @icon="key"
        @label="login.security_key_authenticate"
        id="security-key-authenticate-button"
        class="btn-large btn-primary"
      />
    </div>
  {{else if (or this.showTotpForm this.showBackupCodesForm)}}
    <form class={{this.inputFormClass}}>
      <SecondFactorInput
        {{on "input" (with-event-value (fn (mut this.secondFactorToken)))}}
        @secondFactorMethod={{this.shownSecondFactorMethod}}
        value={{this.secondFactorToken}}
      />
      <DButton
        @action={{this.authenticateToken}}
        @label="submit"
        type="submit"
        class="btn-primary"
      />
    </form>
  {{/if}}

  {{#if this.alternativeMethods.length}}
    <p>
      {{#each this.alternativeMethods as |method index|}}
        {{#if (gt index 0)}}
          <span>&middot;</span>
        {{/if}}
        <span>
          <a
            href
            class="toggle-second-factor-method {{method.class}}"
            {{on "click" (fn this.useAnotherMethod method.id)}}
          >
            {{i18n method.translationKey}}
          </a>
        </span>
      {{/each}}
    </p>
  {{/if}}
{{/unless}}
*/
{
  "id": "03hM6xZk",
  "block": "[[[1,[34,0]],[1,\"\\n\\n\"],[41,[30,0,[\"message\"]],[[[1,\"  \"],[10,0],[15,0,[29,[\"alert \",[30,0,[\"alertClass\"]]]]],[12],[1,[30,0,[\"message\"]]],[13],[1,\"\\n\"]],[]],null],[41,[51,[30,0,[\"loadError\"]]],[[[1,\"  \"],[10,\"h3\"],[12],[1,[30,0,[\"secondFactorTitle\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"customDescription\"]],[[[1,\"    \"],[10,2],[14,0,\"action-description\"],[12],[1,[30,0,[\"customDescription\"]]],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,2],[12],[1,[30,0,[\"secondFactorDescription\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"showSecurityKeyForm\"]],[[[1,\"    \"],[10,0],[14,1,\"security-key\"],[12],[1,\"\\n      \"],[8,[39,3],[[24,1,\"security-key-authenticate-button\"],[24,0,\"btn-large btn-primary\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"authenticateSecurityKey\"]],\"key\",\"login.security_key_authenticate\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,4],[[30,0,[\"showTotpForm\"]],[30,0,[\"showBackupCodesForm\"]]],null],[[[1,\"    \"],[10,\"form\"],[15,0,[30,0,[\"inputFormClass\"]]],[12],[1,\"\\n      \"],[8,[39,5],[[16,2,[30,0,[\"secondFactorToken\"]]],[4,[38,6],[\"input\",[28,[37,7],[[28,[37,8],[[28,[37,9],[[30,0,[\"secondFactorToken\"]]],null]],null]],null]],null]],[[\"@secondFactorMethod\"],[[30,0,[\"shownSecondFactorMethod\"]]]],null],[1,\"\\n      \"],[8,[39,3],[[24,0,\"btn-primary\"],[24,4,\"submit\"]],[[\"@action\",\"@label\"],[[30,0,[\"authenticateToken\"]],\"submit\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]],null]],[]]],[1,\"\\n\"],[41,[30,0,[\"alternativeMethods\",\"length\"]],[[[1,\"    \"],[10,2],[12],[1,\"\\n\"],[42,[28,[37,11],[[28,[37,11],[[30,0,[\"alternativeMethods\"]]],null]],null],null,[[[41,[28,[37,12],[[30,2],0],null],[[[1,\"          \"],[10,1],[12],[1,\"·\"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[10,1],[12],[1,\"\\n          \"],[11,3],[24,6,\"\"],[16,0,[29,[\"toggle-second-factor-method \",[30,1,[\"class\"]]]]],[4,[38,6],[\"click\",[28,[37,8],[[30,0,[\"useAnotherMethod\"]],[30,1,[\"id\"]]],null]],null],[12],[1,\"\\n            \"],[1,[28,[35,13],[[30,1,[\"translationKey\"]]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[1,2]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null]],[]],null]],[\"method\",\"index\"],false,[\"hide-application-sidebar\",\"if\",\"unless\",\"d-button\",\"or\",\"second-factor-input\",\"on\",\"with-event-value\",\"fn\",\"mut\",\"each\",\"-track-array\",\"gt\",\"i18n\"]]",
  "moduleName": "discourse/templates/second-factor-auth.hbs",
  "isStrictMode": false
});